import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styles from '~/src/lib/styles.json';

export default function Spinner() {
	return <FontAwesomeIcon icon={faSpinner} color={styles.COLOR.BRAND_PRIMARY} spin />;
}
